module.exports = __webpack_public_path__ + "img/img_10@2x.8bd70bb4.png";